/**
 * TrendPalettes Component - Created by david on 28/02/18.
 */
import * as React from 'react'
import { newTrendColorPalettes, tourTeamsPalettes, trendColorPalettes } from '../../../screens/DesignCenter/constants'
import { Color as ColorType, Colors, QueryProps } from '../../../types/common'
import Panel from 'antd/lib/collapse/CollapsePanel'
import {
  ApplyButton,
  Bar,
  Color,
  ColorBar,
  ColorContent,
  Container, HeaderIcon, LegendText, PaletteContainer, ShareButton, StyledCollapse, StyledPopOver,
} from './styledComponents'

interface ColorsData extends QueryProps {
  colorsResult: Colors
}

interface Props {
  colorsList: ColorsData
  secondary?: boolean
  copyToClipboard: (value: string) => void
  setTrendColorsAction: (colors: string[]) => void
}

class TrendPalettes extends React.PureComponent<Props> {
  state = {
    colorNames: {},
    colorNamesSet: false
  }
  applyTrendPalette = (evt: React.MouseEvent) => {
    const { currentTarget } = evt || {}
    const { id, dataset } = currentTarget || {}
    const { type } = dataset || {}
    if (id) {
      const index = Number(id)
      const palette = (type === 'new' ? newTrendColorPalettes : 
        (type === 'tour' ? tourTeamsPalettes : trendColorPalettes))[index] || {}
      const colors = palette ? palette.colors : []
      if (colors && colors.length > 0) {
        const { setTrendColorsAction } = this.props
        setTrendColorsAction(colors)
      }
    }
  }

  handleSetColorNames = () => {
    const { colorsList } = this.props
    let colorNames = {}
    if (colorsList && !colorsList.loading) {
      const { colorsResult } = colorsList || {}
      const { colors } = colorsResult || {}
      try {
        const normalColors = JSON.parse(colors || '[]') || []
        colorNames = normalColors.reduce((obj: any, colorItem: ColorType) => {
          if (colorItem && colorItem.name && colorItem.value) {
            obj[colorItem.value] = colorItem.name
          }
          return obj
        // tslint:disable-next-line: align
        }, {}) 
        if (colorNames) {
          this.setState({ colorNames, colorNamesSet: true })
        }
      } catch (e) {
        console.error(e)
      }
    }
  }

  handleClickShare = (evt: React.MouseEvent) => {
    if (evt) {
      evt.stopPropagation()
      evt.preventDefault()
      const { currentTarget } = evt || {}
      const { id } = currentTarget || {}
      const urlParams = new URLSearchParams(window.location.search)
      urlParams.set('cp', id)
      const params = urlParams.toString()
      const url = `${window.location.origin}${window.location.pathname}?${params}`
      const { copyToClipboard } = this.props
      copyToClipboard(url)
    }
  }
  render() {
    const { colorsList, secondary } = this.props
    const { colorNamesSet, colorNames } = this.state
    const colorPalettes = trendColorPalettes.map((paletteItem) => {
      const { name = '', colors = [], globalIndex = 0 } = paletteItem || {}
      const primary = colors[0] || ''
      colors.slice()
      const accentColors = colors || []
      return {
        name,
        primary,
        accentColors,
        globalIndex
      }
    })
    const newColorPalettes = newTrendColorPalettes.map((paletteItem) => {
      const { name = '', colors = [], globalIndex = 0 } = paletteItem || {}
      const primary = colors[0] || ''
      colors.slice()
      const accentColors = colors || []
      return {
        name,
        primary,
        accentColors,
        globalIndex
      }
    })
    if (colorsList && !colorsList.loading && !colorNamesSet) {
      this.handleSetColorNames()
    }
    return (
      <Container {...{ secondary }}>
        <StyledCollapse accordion={true}>
        <Panel 
            header={
              <div>
                <HeaderIcon src="https://storage.googleapis.com/jakroo/homepage/TourPalette-Icon.svg" />
                Tour Teams '26
              </div>
            }
            key="1"
          >
            {tourTeamsPalettes.map((paletteItem, key: number) => {
              const { name = '', colors = [], globalIndex = 0 } = paletteItem || {}
              const primary = colors[0] || ''
              colors.slice()
              const accentColors = colors || []
              return (
              <PaletteContainer
                {...{ secondary, key }}
                id={key.toString()}
                data-type="tour"
                onClick={this.applyTrendPalette}
              >
                <ColorBar>
                  <LegendText>
                    {name}
                    <div style={{ display: 'flex' }}>
                      <ShareButton id={globalIndex} onClick={this.handleClickShare}>Share</ShareButton>
                      {secondary && <ApplyButton>Apply</ApplyButton>}
                    </div>
                  </LegendText>
                  <Bar>
                    {secondary ?
                      <ColorContent secondary={true}>
                        <Color color={primary} />
                      </ColorContent> :
                      <StyledPopOver
                        title={colorNames && colorNames[primary] ? 
                          colorNames[primary] : primary
                        }
                        placement="bottom"
                      >
                        <ColorContent secondary={true}>
                          <Color color={primary} />
                        </ColorContent>
                      </StyledPopOver>
                    }
                    <ColorContent>
                      {accentColors.map((color, keyAccent: number) => secondary ? 
                        <ColorContent>
                          <Color key={keyAccent} color={color} />
                        </ColorContent> :
                        <StyledPopOver
                          title={colorNames && colorNames[color] ? colorNames[color] : color}
                          placement="bottom"
                        >
                          <ColorContent>
                            <Color key={keyAccent} color={color} />
                          </ColorContent>
                        </StyledPopOver>
                      )}
                    </ColorContent>
                  </Bar>
                </ColorBar>
              </PaletteContainer>
              )
            })}
          </Panel>
          <Panel 
            header={
              <div>
                <HeaderIcon src="https://cdn-icons-png.flaticon.com/32/9390/9390517.png" />
                2026 Trends
              </div>
            }
            key="2"
          >
            {newColorPalettes.map((paletteItem, key: number) =>
              <PaletteContainer
                {...{ secondary, key }}
                id={key.toString()}
                data-type="new"
                onClick={this.applyTrendPalette}
              >
                <ColorBar>
                  <LegendText>
                    {paletteItem.name}
                    <div style={{ display: 'flex' }}>
                      <ShareButton id={paletteItem.globalIndex} onClick={this.handleClickShare}>Share</ShareButton>
                      {secondary && <ApplyButton>Apply</ApplyButton>}
                    </div>
                  </LegendText>
                  <Bar>
                    {secondary ?
                      <ColorContent secondary={true}>
                        <Color color={paletteItem.primary} />
                      </ColorContent> :
                      <StyledPopOver
                        title={colorNames && colorNames[paletteItem.primary] ? 
                          colorNames[paletteItem.primary] : paletteItem.primary
                        }
                        placement="bottom"
                      >
                        <ColorContent secondary={true}>
                          <Color color={paletteItem.primary} />
                        </ColorContent>
                      </StyledPopOver>
                    }
                    <ColorContent>
                      {paletteItem.accentColors.map((color, keyAccent: number) => secondary ? 
                        <ColorContent>
                          <Color key={keyAccent} color={color} />
                        </ColorContent> :
                        <StyledPopOver
                          title={colorNames && colorNames[color] ? colorNames[color] : color}
                          placement="bottom"
                        >
                          <ColorContent>
                            <Color key={keyAccent} color={color} />
                          </ColorContent>
                        </StyledPopOver>
                      )}
                    </ColorContent>
                  </Bar>
                </ColorBar>
              </PaletteContainer>
            )}
          </Panel>
          <Panel 
            header={
              <div>
                <HeaderIcon src="https://cdn-icons-png.flaticon.com/32/2919/2919562.png" />
                Classic Trends
              </div>
            } 
            key="3"
          >
            {colorPalettes.map((paletteItem, key: number) =>
              <PaletteContainer
                {...{ secondary, key }}
                id={key.toString()}
                onClick={this.applyTrendPalette}
              >
                <ColorBar>
                  <LegendText>
                    {paletteItem.name}
                    <div style={{ display: 'flex' }}>
                      <ShareButton id={paletteItem.globalIndex} onClick={this.handleClickShare}>Share</ShareButton>
                      {secondary && <ApplyButton>Apply</ApplyButton>}
                    </div>
                  </LegendText>
                  <Bar>
                    {secondary ? 
                      <ColorContent secondary={true}>
                        <Color color={paletteItem.primary} />
                      </ColorContent> :
                      <StyledPopOver
                        title={colorNames && colorNames[paletteItem.primary] ? 
                          colorNames[paletteItem.primary] : paletteItem.primary
                        }
                        placement="bottom"
                      >
                        <ColorContent secondary={true}>
                          <Color color={paletteItem.primary} />
                        </ColorContent>
                      </StyledPopOver>
                    }
                    <ColorContent>
                      {paletteItem.accentColors.map((color, keyAccent: number) => secondary ? 
                        <ColorContent>
                          <Color key={keyAccent} color={color} />
                        </ColorContent> : 
                        <StyledPopOver
                          title={colorNames && colorNames[color] ? colorNames[color] : color}
                          placement="bottom"
                        >
                          <ColorContent>
                            <Color key={keyAccent} color={color} />
                          </ColorContent>
                        </StyledPopOver>
                      )}
                    </ColorContent>
                  </Bar>
                </ColorBar>
              </PaletteContainer>
            )}
          </Panel>
        </StyledCollapse>
      </Container>
    )
  }
}

export default TrendPalettes



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/TrendPalettes/index.tsx